module.exports = __webpack_public_path__ + "assets/img/2.5f77a50d.png";